import type {RefObject} from 'react'
import {type ButtonProps as AriaButtonProps} from 'react-aria-components'

export enum ButtonVariant {
    Solid = 'solid',
    Outlined = 'outlined',
    Icon = 'icon',
}

export enum ButtonSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
}

export interface ButtonStyleProps {
    variant?: ButtonVariant
    size?: ButtonSize
    color?: string
}

export interface ButtonProps extends AriaButtonProps, ButtonStyleProps {
    ref?: RefObject<HTMLButtonElement>
}
